module.exports = __webpack_public_path__ + "img/answer-c3-2.9a81c1b1.png";